import React, { useState } from 'react'
import classnames from 'classnames'

interface Tab {
  title: string
  content: React.ReactNode
}

interface TabsProps {
  tabs: Tab[]
}

const Tabs = ({ tabs }: TabsProps) => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <div className="w-full">
      <div className="mb-4 flex items-center justify-items-start">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={classnames('flex items-center border-b px-6 py-1 text-sm text-white', {
              '!border-main-blue': activeTab === index,
            })}
            onClick={() => setActiveTab(index)}>
            {tab.title}
          </button>
        ))}
      </div>
      <div>{tabs[activeTab]?.content}</div>
    </div>
  )
}

export default Tabs
